import { useState, useEffect, useRef } from 'react'

interface CountdownResult {
  minutes: string
  seconds: string
  isExpired: boolean
}

export function useCountdown(initialSeconds: number): CountdownResult {
  const [remaining, setRemaining] = useState(initialSeconds)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 0) {
          if (intervalRef.current) clearInterval(intervalRef.current)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [])

  const mins = Math.floor(remaining / 60)
  const secs = remaining % 60

  return {
    minutes: mins < 10 ? `0${mins}` : `${mins}`,
    seconds: secs < 10 ? `0${secs}` : `${secs}`,
    isExpired: remaining <= 0,
  }
}
